import register from '@kpsys/angularjs-register';
import {PublicStatsController} from './public-stats.controller';
import {OverallStatsController} from './overall-stats.controller';

export default register('portaro.stats')
    .controller(PublicStatsController.controllerName, PublicStatsController)
    .controller(OverallStatsController.controllerName, OverallStatsController)
    .name();